export enum CONNECTION_STATE {
	UNKNOWN = 0,
	DISCONNECTED = 1,
	CONNECTING = 2,
	CONNECTED = 3,
	REQUESTED = 4,
	INITIALIZING = 5,
	STREAMING = 6,
}